import React, { useState } from 'react';
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Container,
  Paper
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { SetEstudentCreate } from '../../Conections/AcademicConection';
import { can } from '../../Conections/LogConections';

function EstudentCreate() {

  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();
  const idGruop = useParams();

  const [formData, setFormData] = useState({
    codigo: '',
    nombre: '',
    apellido: '',
    email: '',
    estado: ''
  });

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/academic/createestudent/:group");
      if (permisionCan === 0) {
        goTo("/dashboard");
      }
    }
    else {
      goTo(`/login`);
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSelectChange = (e) => {
    setFormData(prevState => ({
      ...prevState,
      estado: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const groupid = Number(idGruop.group);
    const datos = await SetEstudentCreate(
      getToken(),
      getCompany(),
      groupid,
      formData.codigo,
      formData.nombre,
      formData.apellido,
      formData.email,
      formData.estado
    );
    console.log(datos);
    goTo(`/academic/showgroup/${groupid}`);
  };

  return (
    <Container component="main" maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
        <Typography component="h1" variant="h5" gutterBottom>
          Registro de Estudiante
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="codigo"
            label="Código"
            name="codigo"
            autoComplete="off"
            autoFocus
            value={formData.codigo}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="nombre"
            label="Nombre"
            name="nombre"
            autoComplete="given-name"
            value={formData.nombre}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="apellido"
            label="Apellido"
            name="apellido"
            autoComplete="family-name"
            value={formData.apellido}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo Electrónico"
            name="email"
            autoComplete="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="estado-label">Estado</InputLabel>
            <Select
              labelId="estado-label"
              id="estado"
              value={formData.estado}
              label="Estado"
              onChange={handleSelectChange}
            >
              <MenuItem value="1">Activo</MenuItem>
              <MenuItem value="0">Inactivo</MenuItem>
            </Select>
          </FormControl>
          <Button
            type="submit"
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              bgcolor: 'primary.main',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
              width: 'auto',
              mx: 'auto',
              display: 'block'
            }}
          >
            Registrar Estudiante
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default EstudentCreate;